export default "__VITE_ASSET__3iNP4wUc__"